import React from "react";
import { Link } from "react-router-dom";

const Livelihoods = () => {
  return (
    <>
      <section
        className="page-title-section bg-img cover-background top-position1 left-overlay-secondary"
        data-overlay-dark="85"
        style={{
          backgroundImage: 'url("img/banner/banner-livelihoods.jpg")',
        }}
      >
        <div className="container">
          <div className="row position-relative z-index-9">
            <div className="col-md-12">
              <h1>Livelihood</h1>
              <ul>
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>Livelihood</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* BUSINESS STRATEGY */}
      <section>
        <div className="container">
          <div className="row mt-n2-9">
            <div className="col-lg-4 mt-2-9 order-2 order-lg-1">
              <div className="sidebar me-xl-1-9">
                <div
                  className="widget mb-1-9 wow fadeInUp"
                  data-wow-delay="100ms"
                >
                  <h2 className="mb-4 h4">Our Work</h2>
                  <ul className="list-unstyled menu m-0">
                    <li>
                      <Link to="/skill-development">
                        Skill Development<i className="ti-arrow-right"></i>
                      </Link>
                    </li>
                    <li>
                      <Link to="/education">
                        Education<i className="ti-arrow-right"></i>
                      </Link>
                    </li>
                    <li>
                      <Link to="/health">
                        Health<i className="ti-arrow-right"></i>
                      </Link>
                    </li>
                    <li>
                      <Link to="/abled">
                        Inclusion of Differently Abled
                        <i className="ti-arrow-right"></i>
                      </Link>
                    </li>
                    <li>
                      <Link to="/sports">
                        Sports<i className="ti-arrow-right"></i>
                      </Link>
                    </li>
                    <li>
                      <Link to="/community-initiatives">
                        Community Initiatives<i className="ti-arrow-right"></i>
                      </Link>
                    </li>
                    <li className="active">
                      <Link to="/livelihoods">
                        Livelihoods<i className="ti-arrow-right"></i>
                      </Link>
                    </li>
                  </ul>
                </div>
                <div
                  className="widget mb-1-9 wow fadeInUp"
                  data-wow-delay="100ms"
                >
                  <h2 className="mb-4 h4">Follow us</h2>
                  <div className="widget-content">
                    <ul className="social-icon-style2 list-unstyled ps-0">
                          <li className="me-1 d-inline-block"><Link to="https://www.facebook.com/www.shamayitamath.org?mibextid=ZbWKwL"target="blank"><i className="fab fa-facebook-f"></i></Link></li>
                          <li className="me-1 d-inline-block"><Link to="https://youtube.com/@shamayitamath2956?si=s7HKE99MD6pY6Kpb"target="blank"><i className="fa-brands fa-youtube"></i></Link></li>
                          <li className="me-1 d-inline-block"><Link to="https://www.instagram.com/shamayitamath?utm_source=ig_web_button_share_sheet&igsh=ODdmZWVhMTFiMw=="target="blank"><i className="fab fa-instagram"></i></Link></li>
                          <li className="me-0 d-inline-block"><Link to="https://www.linkedin.com/company/shamayitamath/?viewAsMember=true"target="blank"><i className="fab fa-linkedin-in"></i></Link></li>
                        </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-8 mt-2-9 order-1 order-lg-2">
              <div>
                <div
                  className="mb-1-9 mb-lg-5 image-hover wow fadeInUp"
                  data-wow-delay="100ms"
                >
                  <img
                    src="img/service/service-details-livelihood.jpg"
                    alt="..."
                    className="border-radius-10"
                  />
                </div>
                <p className="mb-3 wow fadeInUp" data-wow-delay="100ms">
                  Shamayita Math promotes scientific practices in agriculture,
                  fishery, and livestock among a large percentage of the
                  economically deprived population in over 1,500 villages of
                  Eastern and Central India. Agri-business activities also form
                  a significant part of its work. This has improved the food
                  security and incomes of 68,000 susceptible households. Natural
                  resource management interventions such as de-siltation of
                  irrigation infrastructure, ponds and check dams' development,
                  orchards, and staggered trenches, while improving livelihoods
                  also build resilience of communities against climate change.
                </p>

                {/* Krishani Section */}
                <h2
                  className="mb-4 wow fadeInUp text-primary pt-3"
                  data-wow-delay="100ms"
                >
                  Krishani: Empowering Farmers through a Green Initiative:
                </h2>
                <div className="row align-items-center mb-1-9">
                  <div
                    className="col-xl-6 mb-4 mb-xl-0 wow fadeInUp"
                    data-wow-delay="100ms"
                  >
                    <div className="image-hover">
                      <img
                        src="img/service/livelihoods-1.jpg"
                        alt="..."
                        className="border-radius-10"
                      />
                    </div>
                  </div>
                  <div className="col-xl-6 wow fadeInUp" data-wow-delay="100ms">
                    <p className="mb-0">
                      A prominent green initiative floated by Shamayita Math is
                      a curated store called Krishani in Durgapur, which is
                      devoted to making safe and natural products more
                      accessible. The effort is dedicated to enhancing the
                      incomes of the farmers by providing them a market for
                      their natural farming products, which follow the safety
                      standards.
                    </p>
                  </div>
                  <p className="mb-0" data-wow-delay="150ms">
                    The products comprise paddy, pulses, mustard oil, sunflower,
                    oyster mushrooms, and pesticide-free vegetables.
                  </p>
                </div>

                <div className="row mt-n1-9">
                  <div
                    className="col-md-4 mt-1-9 wow fadeInUp"
                    data-wow-delay="100ms"
                  >
                    <div className="image-hover">
                      <img
                        src="img/service/livelihoods-2.jpg"
                        alt="..."
                        className="border-radius-10"
                      />
                    </div>
                  </div>
                  <div
                    className="col-md-4 mt-1-9 wow fadeInUp"
                    data-wow-delay="100ms"
                  >
                    <div className="image-hover">
                      <img
                        src="img/service/livelihoods-3.jpg"
                        alt="..."
                        className="border-radius-10"
                      />
                    </div>
                  </div>
                  <div
                    className="col-md-4 mt-1-9 wow fadeInUp"
                    data-wow-delay="100ms"
                  >
                    <div className="image-hover">
                      <img
                        src="img/service/livelihoods-4.jpg"
                        alt="..."
                        className="border-radius-10"
                      />
                    </div>
                  </div>
                </div>

                {/* Diverse Offerings */}
                <h4 className="mb-4 wow fadeInUp pt-5" data-wow-delay="100ms">
                  Diverse Offerings:
                </h4>
                <div className="row align-items-center mb-1-9">
                  <div className="col-xl-6 wow fadeInUp" data-wow-delay="100ms">
                    <p className="mb-0">
                      The product range also includes other natural and organic
                      items, such as honey, date jaggery, and handicrafts from
                      Bankura like terracotta, bamboo crafts, and jute bags.
                      Those interested in raising plants in their homes can buy
                      seedlings, fruit saplings, and indoor plants. One can also
                      find bio inputs such as bio manures and bio-pesticides
                      sold for advancing eco-friendly farming practices.
                    </p>
                  </div>
                  <div
                    className="col-xl-6 mb-4 mb-xl-0 wow fadeInUp"
                    data-wow-delay="100ms"
                  >
                    <div className="image-hover">
                      <img
                        src="img/service/livelihoods-5.jpg"
                        alt="..."
                        className="border-radius-10"
                      />
                    </div>
                  </div>
                </div>

                {/* Growing Together */}
                <h4 className="mb-4 wow fadeInUp pt-5" data-wow-delay="100ms">
                  Growing Together:
                </h4>
                <div className="row align-items-center mb-1-9">
                  <div
                    className="col-xl-6 mb-4 mb-xl-0 wow fadeInUp"
                    data-wow-delay="100ms"
                  >
                    <div className="image-hover">
                      <img
                        src="img/service/livelihoods-6.jpg"
                        alt="..."
                        className="border-radius-10"
                      />
                    </div>
                  </div>
                  <div className="col-xl-6 wow fadeInUp" data-wow-delay="100ms">
                    <p className="mb-0">
                      Through the linkage created between farmers and urban
                      consumers, Krishani is developing strong bonds between
                      rural and urban communities while furthering sustainable
                      livelihoods.
                    </p>
                  </div>
                </div>

                {/* Impacts */}
                <h4 className="mb-4 wow fadeInUp" data-wow-delay="100ms">
                  Impacts:
                </h4>
                <div className="row mb-1-9 wow fadeInUp" data-wow-delay="100ms">
                  <div className="col-md-12 mb-4 mb-md-0">
                    <div className="d-flex align-items-center border border-color-light-black p-2 mb-3">
                      <i className="fa-solid fa-circle-check display-26 text-primary"></i>
                      <span className="ms-3 text-dark fw-bold">
                        Farmers get better prices as they can sell their products directly without any intermediary.
                      </span>
                    </div>
                    <div className="d-flex align-items-center border border-color-light-black p-2 mb-3">
                      <i className="fa-solid fa-circle-check display-26 text-primary"></i>
                      <span className="ms-3 text-dark fw-bold">
                        It promotes natural and safe products which advances eco-friendly products and farm practices.
                      </span>
                    </div>
                    <div className="d-flex align-items-center border border-color-light-black p-2 mb-3">
                      <i className="fa-solid fa-circle-check display-26 text-primary"></i>
                      <span className="ms-3 text-dark fw-bold">
                        This effort is diversifying income opportunities for the farmers and rural artisans.
                      </span>
                    </div>
                    <div className="d-flex align-items-center border border-color-light-black p-2">
                      <i className="fa-solid fa-circle-check display-26 text-primary"></i>
                      <span className="ms-3 text-dark fw-bold">
                        It is boosting self-reliance and creating ideas for entrepreneurship among farmers and rural artisans.
                      </span>
                    </div>
                  </div>
                </div>

                {/* SKKLLP Section */}
                <h2
                  className="mb-4 wow fadeInUp text-primary pt-5"
                  data-wow-delay="100ms"
                >
                  SKKLLP:
                </h2>
                <div className="row align-items-center mb-1-9">
                  <div
                    className="col-xl-6 mb-4 mb-xl-0 wow fadeInUp"
                    data-wow-delay="100ms"
                  >
                    <div className="image-hover">
                      <img
                        src="img/service/livelihoods-11.jpg"
                        alt="..."
                        className="border-radius-10"
                      />
                    </div>
                  </div>
                  <div className="col-xl-6 wow fadeInUp" data-wow-delay="100ms">
                    <p className="mb-0">
                      The Shamayita Krishi Kendra Limited Liability Partnership
                      (SKKLLP), originally known as Shamayita Krishi Kendra
                      (SKK), was set up in 2004 to improve the agriculture in
                      the Bankura region. An early important milestone in SKK's
                      evolution was in 2005 when a collaboration was established
                      with the Syngenta Foundation, which provided high-quality
                      seeds to farmers. The initiative
                    </p>
                  </div>
                  <p className="mb-3" data-wow-delay="150ms">
                    that started with the provision of foundation seeds has seen
                    major expansion including the development of godwon under
                    the Agri Infrastructure Fund (AIF), grading center, and
                    handling various crops like mustard, masoor dal, and okra
                    under the 'Sirohi' brand.
                  </p>
                  <p className="mb-0" data-wow-delay="150ms">
                    The SKKLLP umbrella, today, also includes fruit and flower
                    saplings, a vegetable nursery, and a dairy unit, which has a
                    partnership with the Kangsaboti Co-operative Milk Producers'
                    Union Ltd. This collaboration has improved the earnings of
                    the local milk producers. Today, around 1,000 farmers are
                    deriving significant benefits from this initiative including
                    relevant support such as training, an assured market, and
                    resources. The venture's annual output, now, stands in
                    excess of 800 metric tons of produce. SKKLLP places a
                    special emphasis on high quality as well as genetic purity.
                    It procures various produce at a price higher than the
                    market rate. Moreover, important collaborations with
                    organizations such as TCL and E&Y are further driving up the
                    development of farmers including women farmers and farm
                    economy infrastructure.
                  </p>
                </div>

                <div className="row mt-n1-9">
                  <div
                    className="col-md-4 mt-1-9 wow fadeInUp"
                    data-wow-delay="100ms"
                  >
                    <div className="image-hover">
                      <img
                        src="img/service/livelihoods-12.jpg"
                        alt="..."
                        className="border-radius-10"
                      />
                    </div>
                  </div>
                  <div
                    className="col-md-4 mt-1-9 wow fadeInUp"
                    data-wow-delay="100ms"
                  >
                    <div className="image-hover">
                      <img
                        src="img/service/livelihoods-13.jpg"
                        alt="..."
                        className="border-radius-10"
                      />
                    </div>
                  </div>
                  <div
                    className="col-md-4 mt-1-9 wow fadeInUp"
                    data-wow-delay="100ms"
                  >
                    <div className="image-hover">
                      <img
                        src="img/service/livelihoods-14.jpg"
                        alt="..."
                        className="border-radius-10"
                      />
                    </div>
                  </div>
                </div>

                {/* SKKLLP Impacts */}
                <h4 className="mb-4 wow fadeInUp pt-5" data-wow-delay="100ms">
                  Impacts:
                </h4>
                <div className="row mb-1-9 wow fadeInUp" data-wow-delay="100ms">
                  <div className="col-md-12 mb-4 mb-md-0">
                    <div className="d-flex align-items-center border border-color-light-black p-3 mb-3">
                      <i className="fa-solid fa-circle-check display-26 text-primary"></i>
                      <span className="ms-3 text-dark fw-bold">
                        Farmers have benefited through training resulting in improved farm practices.
                      </span>
                    </div>
                    <div className="d-flex align-items-center border border-color-light-black p-3 mb-3">
                      <i className="fa-solid fa-circle-check display-26 text-primary"></i>
                      <span className="ms-3 text-dark fw-bold">
                        The provision of support such as high-quality seeds has raised crop yields.
                      </span>
                    </div>
                    <div className="d-flex align-items-center border border-color-light-black p-3 mb-3">
                      <i className="fa-solid fa-circle-check display-26 text-primary"></i>
                      <span className="ms-3 text-dark fw-bold">
                        Diverse crops add to better incomes for farmers.
                      </span>
                    </div>
                    <div className="d-flex align-items-center border border-color-light-black p-3 mb-3">
                      <i className="fa-solid fa-circle-check display-26 text-primary"></i>
                      <span className="ms-3 text-dark fw-bold">
                        Milk producers also gained economically through expanded markets.
                      </span>
                    </div>
                    <div className="d-flex align-items-center border border-color-light-black p-3">
                      <i className="fa-solid fa-circle-check display-26 text-primary"></i>
                      <span className="ms-3 text-dark fw-bold">
                        It has strengthened the role of women farmers in the agricultural economy.
                      </span>
                    </div>
                  </div>
                </div>

                {/* FPCs Development */}
                <h2
                  className="mb-4 wow fadeInUp text-primary pt-5"
                  data-wow-delay="100ms"
                >
                  Farmers Producer Companies (FPCs) Development:
                </h2>
                <div className="row align-items-center mb-1-9">
                  <div
                    className="col-xl-6 mb-4 mb-xl-0 wow fadeInUp"
                    data-wow-delay="100ms"
                  >
                    <div className="image-hover">
                      <img
                        src="img/service/livelihoods-15.jpg"
                        alt="..."
                        className="border-radius-10"
                      />
                    </div>
                  </div>
                  <div className="col-xl-6 wow fadeInUp" data-wow-delay="100ms">
                    <p className="mb-0">
                      A key farm business project is that of Shamayita Math's
                      function as a Cluster-Based Business Organization (CBBO)
                      under the Government of India's 10,000 FPO initiative. The
                      Small Farmers Agribusiness Consortium (SFAC) within the
                      Ministry of Agriculture and Farmers Welfare implements the
                      10,000 FPO initiative.
                    </p>
                  </div>
                  <p className="mb-3" data-wow-delay="150ms">
                    The project is strengthening farmer institutions and
                    developing viable rural livelihoods. The effort has reached
                    7,200 farmers through the formation of 16 FPCs and provides
                    affordable and good quality inputs, technical assistance,
                    and market access. It has created linkages with the
                    government welfare programs. The FPCs have worked on
                    creating branded products with improved packaging and market
                    presence. The average annual transaction of each FPC is
                    around Rs. 25 lakhs and farmers are getting fair prices for
                    their products. Moreover, the effort has achieved an overall
                    turnover of Rs. 10.50 crores through these FPCs.
                  </p>
                </div>

                <div className="row mt-n1-9">
                  <div
                    className="col-md-4 mt-1-9 wow fadeInUp"
                    data-wow-delay="100ms"
                  >
                    <div className="image-hover">
                      <img
                        src="img/service/livelihoods-16.jpg"
                        alt="..."
                        className="border-radius-10"
                      />
                    </div>
                  </div>
                  <div
                    className="col-md-4 mt-1-9 wow fadeInUp"
                    data-wow-delay="100ms"
                  >
                    <div className="image-hover">
                      <img
                        src="img/service/livelihoods-17.jpg"
                        alt="..."
                        className="border-radius-10"
                      />
                    </div>
                  </div>
                  <div
                    className="col-md-4 mt-1-9 wow fadeInUp"
                    data-wow-delay="100ms"
                  >
                    <div className="image-hover">
                      <img
                        src="img/service/livelihoods-18.jpg"
                        alt="..."
                        className="border-radius-10"
                      />
                    </div>
                  </div>
                </div>

                {/* FPCs Impacts */}
                <h4 className="mb-4 wow fadeInUp pt-5" data-wow-delay="100ms">
                  Impacts:
                </h4>
                <div className="row mb-1-9 wow fadeInUp" data-wow-delay="100ms">
                  <div className="col-md-12 mb-4 mb-md-0">
                    <div className="d-flex align-items-center border border-color-light-black p-3 mb-3">
                      <i className="fa-solid fa-circle-check display-26 text-primary"></i>
                      <span className="ms-3 text-dark fw-bold">
                        Easy access to technical support and quality inputs at affordable prices without having to struggle for them.
                      </span>
                    </div>
                    <div className="d-flex align-items-center border border-color-light-black p-3 mb-3">
                      <i className="fa-solid fa-circle-check display-26 text-primary"></i>
                      <span className="ms-3 text-dark fw-bold">
                        Fair prices have increased the incomes of farmers.
                      </span>
                    </div>
                    <div className="d-flex align-items-center border border-color-light-black p-3 mb-3">
                      <i className="fa-solid fa-circle-check display-26 text-primary"></i>
                      <span className="ms-3 text-dark fw-bold">
                        Government welfare programs access is improving the farmers' lives.
                      </span>
                    </div>
                    <div className="d-flex align-items-center border border-color-light-black p-3">
                      <i className="fa-solid fa-circle-check display-26 text-primary"></i>
                      <span className="ms-3 text-dark fw-bold">
                        A viable business model is in place for better livelihoods.
                      </span>
                    </div>
                  </div>
                </div>

                {/* CIRTD Section */}
                <h2
                  className="mb-4 wow fadeInUp text-primary pt-5"
                  data-wow-delay="100ms"
                >
                  CIRTD:
                </h2>
                <h4 className="mb-4 wow fadeInUp pt-2" data-wow-delay="100ms">
                  Building Sustainable Livelihoods Pathways:
                </h4>
                <div className="row align-items-center mb-1-9">
                  <div
                    className="col-xl-6 mb-4 mb-xl-0 wow fadeInUp"
                    data-wow-delay="100ms"
                  >
                    <div className="image-hover">
                      <img
                        src="img/service/livelihoods-19.jpg"
                        alt="..."
                        className="border-radius-10"
                      />
                    </div>
                  </div>
                  <div className="col-xl-6 wow fadeInUp" data-wow-delay="100ms">
                    <p className="mb-0">
                      The Centre for Integrated Rural and Tribal Development
                      (CIRTD) at Shamayita Math works on advancing sustainable
                      livelihoods and natural farming practices among rural and
                      tribal communities through agriculture extension work.
                    </p>
                  </div>
                  <p className="mb-3" data-wow-delay="150ms">
                    It works on strengthening traditional farming practices
                    including the use of conventional seeds such as 'desi dhan'
                    (local paddy) and natural farming techniques for resource
                    improvement. It works on developing sustainable community
                    institutions and leadership among women farmers for better
                    livelihoods and prices.
                  </p>
                </div>

                {/* Diversified Income Opportunities */}
                <h4 className="mb-4 wow fadeInUp pt-2" data-wow-delay="100ms">
                  Diversified Income Opportunities:
                </h4>
                <div className="row align-items-center mb-1-9">
                  <div className="col-xl-6 wow fadeInUp" data-wow-delay="100ms">
                    <p className="mb-0">
                      CIRTD's income diversification work includes pulse
                      production and mushroom farming. Besides, nutrition garden
                      development for organic fruit and vegetable production is
                      also emphasized. It underlines the development of both
                      on-farm and off-farm activities. This includes organic
                      farming, livestock management comprising goat rearing and
                      backyard poultry, fisheries,
                    </p>
                  </div>
                  <div
                    className="col-xl-6 mb-4 mb-xl-0 wow fadeInUp"
                    data-wow-delay="100ms"
                  >
                    <div className="image-hover">
                      <img
                        src="img/service/livelihoods-20.jpg"
                        alt="..."
                        className="border-radius-10"
                      />
                    </div>
                  </div>
                  <p className="mb-3" data-wow-delay="150ms">
                    and access to entitlements. The small enterprises' segment
                    in this effort includes puff rice, bel mala, and fish hook
                    making.
                  </p>
                </div>

                {/* Convergence with Government Programs */}
                <h4 className="mb-4 wow fadeInUp pt-2" data-wow-delay="100ms">
                  Convergence with Government Programs:
                </h4>
                <div className="row align-items-center mb-1-9">
                  <div
                    className="col-xl-6 mb-4 mb-xl-0 wow fadeInUp"
                    data-wow-delay="100ms"
                  >
                    <div className="image-hover">
                      <img
                        src="img/service/livelihoods-21.jpg"
                        alt="..."
                        className="border-radius-10"
                      />
                    </div>
                  </div>
                  <div className="col-xl-6 wow fadeInUp" data-wow-delay="100ms">
                    <p className="mb-0">
                      A special emphasis is placed on developing convergence
                      with various government programs to generate additional
                      funds to ensure a wider reach and better quality of work.
                      As part of this, close collaborations with various
                      relevant government agencies including the panchayats are
                      developed. This approach is useful in undertaking
                      community
                    </p>
                  </div>
                  <p className="mb-3" data-wow-delay="150ms">
                    works such as de-silting irrigation channels, ponds and
                    check dams' construction, social forestry, and staggered
                    trenches. This CIRTD's efforts are especially enabling the
                    creation of improved earning opportunities for ultra-poor
                    families and are combating migration and food insecurity.
                  </p>
                  <p className="mb-3" data-wow-delay="150ms">
                    The strengthening of the CIRTD's work has been acknowledged
                    by many partners such as the Azim Premji Foundation, EY
                    Foundation, and others who have associated with and
                    supported this effort.
                  </p>
                </div>

                <div className="row mt-n1-9">
                  <div
                    className="col-md-4 mt-1-9 wow fadeInUp"
                    data-wow-delay="100ms"
                  >
                    <div className="image-hover">
                      <img
                        src="img/service/livelihoods-22.jpg"
                        alt="..."
                        className="border-radius-10"
                      />
                    </div>
                  </div>
                  <div
                    className="col-md-4 mt-1-9 wow fadeInUp"
                    data-wow-delay="100ms"
                  >
                    <div className="image-hover">
                      <img
                        src="img/service/livelihoods-23.jpg"
                        alt="..."
                        className="border-radius-10"
                      />
                    </div>
                  </div>
                  <div
                    className="col-md-4 mt-1-9 wow fadeInUp"
                    data-wow-delay="100ms"
                  >
                    <div className="image-hover">
                      <img
                        src="img/service/livelihoods-24.jpg"
                        alt="..."
                        className="border-radius-10"
                      />
                    </div>
                  </div>
                </div>

                {/* CIRTD Impacts */}
                <h4 className="mb-4 wow fadeInUp pt-5" data-wow-delay="100ms">
                  Impacts:
                </h4>
                <div className="row mb-1-9 wow fadeInUp" data-wow-delay="100ms">
                  <div className="col-md-12 mb-4 mb-md-0">
                    <div className="d-flex align-items-center border border-color-light-black p-3 mb-3">
                      <i className="fa-solid fa-circle-check display-26 text-primary"></i>
                      <span className="ms-3 text-dark fw-bold">
                        The natural farming methods and conventional seeds that are native to local rural and tribal communities are being harnessed to enhance livelihoods.
                      </span>
                    </div>
                    <div className="d-flex align-items-center border border-color-light-black p-3 mb-3">
                      <i className="fa-solid fa-circle-check display-26 text-primary"></i>
                      <span className="ms-3 text-dark fw-bold">
                        Diversification of income sources comprising both on and off-farm activities is consolidating local incomes and eliminating the need for migration.
                      </span>
                    </div>
                    <div className="d-flex align-items-center border border-color-light-black p-3 mb-3">
                      <i className="fa-solid fa-circle-check display-26 text-primary"></i>
                      <span className="ms-3 text-dark fw-bold">
                        Organic food products are also improving the food security and nutrition profile of the villagers.
                      </span>
                    </div>
                    <div className="d-flex align-items-center border border-color-light-black p-3">
                      <i className="fa-solid fa-circle-check display-26 text-primary"></i>
                      <span className="ms-3 text-dark fw-bold">
                        Local communities especially ultra-poor and women farmers are getting further uplifted through community leadership and institutions.
                      </span>
                    </div>
                  </div>
                </div>

                {/* Soil Testing Laboratory */}
                <h2
                  className="mb-4 wow fadeInUp text-primary pt-3"
                  data-wow-delay="100ms"
                >
                  Soil Testing Laboratory:
                </h2>
                <div className="row align-items-center mb-1-9">
                  <div
                    className="col-xl-6 mb-4 mb-xl-0 wow fadeInUp"
                    data-wow-delay="100ms"
                  >
                    <div className="image-hover">
                      <img
                        src="img/service/livelihoods-25.jpg"
                        alt="..."
                        className="border-radius-10"
                      />
                    </div>
                  </div>
                  <div className="col-xl-6 wow fadeInUp" data-wow-delay="100ms">
                    <p className="mb-0">
                      The Soil Testing Laboratory at Shamayita Math in
                      Amarkanan, Bankura District, is a community-based facility
                      that supports farmers with scientific soil analysis to
                      enhance agricultural productivity and sustainability.
                      Managed by trained staffs, the laboratory analyses soil
                      samples to uncover critical information that guides
                      farmers in improving soil health and crop management
                      practices.
                    </p>
                  </div>
                </div>

                <div className="row align-items-center mb-1-9">
                  <div className="col-xl-6 wow fadeInUp" data-wow-delay="100ms">
                    <p className="mb-0">
                      The laboratory tests twelve key soil parameters including
                      pH, Electrical Conductivity (EC), Organic Carbon,
                      Nitrogen, Phosphorus, Potassium, Sulphur, Boron, and
                      essential micronutrients such as Copper (Cu), Iron (Fe),
                      Manganese (Mn), and Zinc (Zn). Based on these results,
                      farmers receive soil health cards along with customized
                      fertilizer and nutrient management recommendations. This
                      enables farmers to optimize input use, enhance crop
                      yields, and reduce excessive chemical application, thereby
                      protecting soil and environmental health. The Soil Testing
                      Laboratory aligns with national and state initiatives such
                      as the Rashtriya Krishi Vikas Yojana (RKVY) and Pradhan
                      Mantri Krishi Vikas Yojana (PKVY). Through these linkages,
                      the initiative contributes to promoting sustainable
                      agriculture, strengthening farmers' decision-making, and
                      improving long-term soil fertility and farming practices
                      in rural and tribal communities.
                    </p>
                  </div>
                  <div
                    className="col-xl-6 mb-4 mb-xl-0 wow fadeInUp"
                    data-wow-delay="100ms"
                  >
                    <div className="image-hover">
                      <img
                        src="img/service/livelihoods-26.jpg"
                        alt="..."
                        className="border-radius-10"
                      />
                    </div>
                  </div>
                </div>

                <div className="row mt-n1-9">
                  <div
                    className="col-md-4 mt-1-9 wow fadeInUp"
                    data-wow-delay="100ms"
                  >
                    <div className="image-hover">
                      <img
                        src="img/service/livelihoods-27.jpg"
                        alt="..."
                        className="border-radius-10"
                      />
                    </div>
                  </div>
                  <div
                    className="col-md-4 mt-1-9 wow fadeInUp"
                    data-wow-delay="100ms"
                  >
                    <div className="image-hover">
                      <img
                        src="img/service/livelihoods-28.jpg"
                        alt="..."
                        className="border-radius-10"
                      />
                    </div>
                  </div>
                  <div
                    className="col-md-4 mt-1-9 wow fadeInUp"
                    data-wow-delay="100ms"
                  >
                    <div className="image-hover">
                      <img
                        src="img/service/livelihoods-29.jpg"
                        alt="..."
                        className="border-radius-10"
                      />
                    </div>
                  </div>
                </div>

                {/* Soil Testing Laboratory Impacts */}
                <h4 className="mb-4 wow fadeInUp pt-5" data-wow-delay="100ms">
                  Impacts:
                </h4>
                <div className="row mb-1-9 wow fadeInUp" data-wow-delay="100ms">
                  <div className="col-md-12 mb-4 mb-md-0">
                    <div className="d-flex align-items-center border border-color-light-black p-3 mb-3">
                      <i className="fa-solid fa-circle-check display-26 text-primary"></i>
                      <span className="ms-3 text-dark fw-bold">
                        Farmers receive scientific soil health assessments and tailored nutrient recommendations.
                      </span>
                    </div>
                    <div className="d-flex align-items-center border border-color-light-black p-3 mb-3">
                      <i className="fa-solid fa-circle-check display-26 text-primary"></i>
                      <span className="ms-3 text-dark fw-bold">
                        Efficient use of fertilizers reduces production costs and environmental risks.
                      </span>
                    </div>
                    <div className="d-flex align-items-center border border-color-light-black p-3 mb-3">
                      <i className="fa-solid fa-circle-check display-26 text-primary"></i>
                      <span className="ms-3 text-dark fw-bold">
                        Improved soil fertility and balanced nutrient management enhance crop productivity.
                      </span>
                    </div>
                  </div>
                </div>

                {/* Agroecological Centre of Excellence (ACE) */}
                <h2
                  className="mb-4 wow fadeInUp text-primary pt-3"
                  data-wow-delay="100ms"
                >
                  Agroecological Centre of Excellence (ACE):
                </h2>
                <div className="row align-items-center mb-1-9">
                  <div
                    className="col-xl-6 mb-4 mb-xl-0 wow fadeInUp"
                    data-wow-delay="100ms"
                  >
                    <div className="image-hover">
                      <img
                        src="img/service/livelihoods-7.jpg"
                        alt="..."
                        className="border-radius-10"
                      />
                    </div>
                  </div>
                  <div className="col-xl-6 wow fadeInUp" data-wow-delay="100ms">
                    <p className="mb-0">
                      The agri-business efforts of the Shamayita Math
                      concentrate on providing quality inputs, technical
                      training and support, branding and packaging, better
                      market access and prices to the local farmers.
                    </p>
                  </div>
                </div>

                <div className="row mt-n1-9">
                  <div
                    className="col-md-4 mt-1-9 wow fadeInUp"
                    data-wow-delay="100ms"
                  >
                    <div className="image-hover">
                      <img
                        src="img/service/livelihoods-8.jpg"
                        alt="..."
                        className="border-radius-10"
                      />
                    </div>
                  </div>
                  <div
                    className="col-md-4 mt-1-9 wow fadeInUp"
                    data-wow-delay="100ms"
                  >
                    <div className="image-hover">
                      <img
                        src="img/service/livelihoods-9.jpg"
                        alt="..."
                        className="border-radius-10"
                      />
                    </div>
                  </div>
                  <div
                    className="col-md-4 mt-1-9 wow fadeInUp"
                    data-wow-delay="100ms"
                  >
                    <div className="image-hover">
                      <img
                        src="img/service/livelihoods-10.jpg"
                        alt="..."
                        className="border-radius-10"
                      />
                    </div>
                  </div>
                </div>

                {/* ACE Impacts */}
                <h4 className="mb-4 wow fadeInUp pt-5" data-wow-delay="100ms">
                  Impacts:
                </h4>
                <div className="row mb-1-9 wow fadeInUp" data-wow-delay="100ms">
                  <div className="col-md-12 mb-4 mb-md-0">
                    <div className="d-flex align-items-center border border-color-light-black p-3 mb-3">
                      <i className="fa-solid fa-circle-check display-26 text-primary"></i>
                      <span className="ms-3 text-dark fw-bold">
                        Farmers gain practical training in agroecology, natural inputs, and traditional pest management.
                      </span>
                    </div>
                    <div className="d-flex align-items-center border border-color-light-black p-3 mb-3">
                      <i className="fa-solid fa-circle-check display-26 text-primary"></i>
                      <span className="ms-3 text-dark fw-bold">
                        Soil health and biodiversity are restored through regenerative and indigenous farming practices.
                      </span>
                    </div>
                    <div className="d-flex align-items-center border border-color-light-black p-3 mb-3">
                      <i className="fa-solid fa-circle-check display-26 text-primary"></i>
                      <span className="ms-3 text-dark fw-bold">
                        Low-cost, nature-positive agriculture enhances farm resilience and farmer incomes.
                      </span>
                    </div>
                    <div className="d-flex align-items-center border border-color-light-black p-3 mb-3">
                      <i className="fa-solid fa-circle-check display-26 text-primary"></i>
                      <span className="ms-3 text-dark fw-bold">
                        Communities and institutions are inspired to adopt ethical, economical, and ecological farming models.
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="scroll-top-percentage">
          <span id="scroll-value"></span>
        </div>
      </section>
    </>
  );
};

export default Livelihoods;